<script>
  export let color;
  export let highlightColor;
  export let name;
  export let editable = false;
</script>

<div class="player" class:editable={editable}>
  <div class="color-ring" style={`
    background-color: ${color};
    border-color: ${highlightColor || 'transparent'};
  `}></div>
  <span>{name}</span>
</div>

<style>
  .player {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 1em;
  }
  .player.editable {
    font-weight: bold;
  }
  .color-ring {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-bottom: 4px;
    border-width: 2px;
    border-style: solid;
  }
</style>